import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography, Card } from "@mui/material";
import Chart from 'react-apexcharts';

function OEE(props) {
    const getColor = () => {
        let color;
        try {
            if (props.value >= 80) {
                color = "#00E396"
            } else if (props.value <= 79) {
                color = "#FCEE9E"
            }
            return color;
        }
        catch {
            console.log()
        }
    }
    return (
        <>
        <Card sx={{ bgcolor: "#ECF8F8", height: '260px' }} style={{ position: "relative", top: "30px" }}>
            <Typography color="black" fontSize={'30px'} fontWeight="bold" align='left' sx={{ pt: 0, ml: 1 }} >
                {props.title}
            </Typography>
            <Box sx={{ display: 'block' }}>
                <Chart
                    options={{
                        chart: {
                            type: 'radialBar',
                            offsetY: -20,
                            offsetX: -40,
                            parentHeightOffset: 0,
                            toolbar: {
                                show: false
                            }
                        },
                        plotOptions: {
                            radialBar: {
                                hollow: {
                                    margin: 0,
                                    size: "60%",
                                },

                                dataLabels: {
                                    showOn: "always",
                                    name: {
                                        offsetY: 20,
                                        show: false,
                                        color: "#888",
                                        fontSize: "15px",
                                        fontFamily: 'CPF_Imm_Sook'
                                    },
                                    value: {
                                        offsetY: 15,
                                        color: "#111",
                                        fontSize: "38px",
                                        fontFamily: 'CPF_Imm_Sook',
                                        show: true
                                    }
                                }
                            }
                        },
                        colors: [getColor()],
                        labels: ['Target 85%'],
                        fill: {
                            type: "gradient",
                            gradient: {
                                shade: "dark",
                                type: "vertical",
                                gradientToColors: [getColor()],
                                stops: [0, 100]
                            }
                        },
                    }}
                    series={props.value != 'NA' ? props.value : 0}
                    type="radialBar"
                    width="150%"
                    height="150%"
                />
            </Box>
            </Card>
        </>
    )
}

OEE.propTypes = {}

export default OEE
